import React from "react";
import useTheme from "@mui/material/styles/useTheme";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CallIcon from "@mui/icons-material/Call";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Section } from "@arp/react-ndbx";
import { URLS } from "../../../config/const/enums";

export default function ContactUsModal({ open, handleClose, contactUsImg }) {
  const theme = useTheme();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
    },
    maxWidth: 640,
    maxHeight: "calc(100vh - 1rem)",
    bgcolor: `${theme.palette.base.White}`,
    borderRadius: "4px",
    pb: 4,
    pl: 4,
    pr: 3,
    pt: 3,
    // overflowY: {
    //   xs: "auto",
    //   sm: "hidden",
    // },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Section
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            mt: 0,
            mb: 0,
          }}
        >
          <CloseIcon
            onClick={handleClose}
            justify="center"
            alignItems="center"
            sx={{ cursor: "pointer" }}
          ></CloseIcon>
        </Section>
        <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
          <Section sx={{ maxWidth: { xs: 334 }, mb: 0 }}>
            <img width="100%" src={contactUsImg}></img>
          </Section>
        </Section>
        <Section sx={{ mt: 0, mb: 3 }}>
          <Typography id="modal-modal-title" variant="h3-regular">
            Need Help?
          </Typography>
        </Section>
        <Section sx={{ mb: 0, mt: 0 }}>
          <Typography id="modal-modal-description" variant="p3" sx={{ mt: 2 }}>
            We're here to help you
          </Typography>
        </Section>
        <Section sx={{ mt: 0, mb: 4 }}>
          <Typography variant="p2-bold">
            Mon - Fri : 9am - 6pm AEDT/AEST
          </Typography>
        </Section>
        <Section sx={{ mb: 4, mt: 0 }}>
          <Section sx={{ maxWidth: "162px" }}>
            <Button
              id="contact-us"
              ariaLabel="Contact-us"
              color="secondary"
              variant="contained"
              label="Primary"
              size="medium"
              sx={{ textTransform: "none" }}
              startIcon={<CallIcon />}
              href={URLS.CONTACT_US_PHONE_URL}
            >
              {URLS.CONTACT_US_PHONE_NUMBER}
            </Button>
          </Section>
        </Section>
      </Box>
    </Modal>
  );
}
